import angular from "angular";
import StudentLocationsCreateResidenceController from "./student-add-residence.controller";
import template from "./student-add-residence.html";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state(
    "drivecoach.student.dashboard.locations.create.residence",
    {
      url: "/residence",
      controller: StudentLocationsCreateResidenceController,
      controllerAs: "vm",
      template: template,
      data: {
        authorizedRoles: [
          USER_ROLES.admin,
          USER_ROLES.administrator,
          USER_ROLES.owner,
          USER_ROLES.student,
        ],
      },
    },
  );
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("student.dashboard.locations.create.residence", [])
  .config(config)
  .controller(
    "StudentLocationsCreateResidenceController",
    StudentLocationsCreateResidenceController,
  );

